import { useEffect, useState } from "react";

const useTextExtraction = (text) => {
  const extractTexts = (inputText) => {
    const titleMatch = inputText.match(/제목\s*:\s*([^내용]*)/);
    const contentMatch = inputText.match(/내용\s*:\s*(.*)/);

    // Case 1: 제목: / 내용: 둘 다 존재하면
    if (titleMatch || contentMatch) {
    return {
      topText: titleMatch ? titleMatch[1].trim() : "",
      bottomText: contentMatch ? contentMatch[1].trim() : "",
    };
    }

    // Case 2: ":"만 있는 경우 → 첫 ":" 기준 분리
    const colonIndex = inputText.indexOf(":");
    if (colonIndex !== -1) {
      const top = inputText.slice(0, colonIndex).trim();
      const bottom = inputText.slice(colonIndex + 1).trim();
      return {
        topText: top,
        bottomText: bottom,
      };
    }

    // Case 3: 두 줄이면 마지막 줄을 bottomText로 사용
    const lines = inputText.trim().split("\n");
    if (lines.length > 1) {
      return {
        topText: lines[0].trim(),
        bottomText: lines[lines.length - 1].trim(),
      };
    }

    // Case 4: 아무 형식도 안 맞으면 전부 bottomText로
    return {
      topText: "",
      bottomText: inputText.trim(),
    };
  };

  const initial = extractTexts(text);
  const [editTopText, setEditTopText] = useState(initial.topText);
  const [editBotText, setEditBotText] = useState(initial.bottomText);

  useEffect(() => {
    const { topText, bottomText } = extractTexts(text);
    setEditTopText(topText);
    setEditBotText(bottomText);
  }, [text]);

  const handleTop = (e) => setEditTopText(e.target.innerText);
  const handleBot = (e) => setEditBotText(e.target.innerText);

  return { editTopText, editBotText, handleTop, handleBot };
};


export default useTextExtraction;
